<template>
  <container>
    <div class="index__section grid grid--large">
      <div class="grid__item">
        <introduction
          class="index__item"
          :title="$t('introduction.title')"
        >
          {{ $t('introduction.text') }}
        </introduction>
      </div>
    </div>

    <transition name="transition-fade">
      <div class="index__section grid grid--large grid--entrance">
        <div
          v-for="item in $t('entrances')"
          :key="item.title"
          class="grid__item grid__item--1/3"
        >
          <entrance
            class="index__item"
            :title="item.title"
            :subtitle="item.subtitle"
            :contenttitle="item.contenttitle"
            :icon="item.icon"
            :link-internal="item.link.internal"
            :link-external="item.link.external"
          >
            <template #content>
              <p
                v-if="item.content"
                v-html="item.content"
              />
              <check-list
                v-if="item.benefits"
                :items="Object.values(item.benefits)"
                color="secondary"
                class="index__check-list"
              />
            </template>

            <template #footer>
              <payment-methods v-if="item.paymentMethods" />

              <action-link
                :router-link="item.link.internal"
                :href="item.link.external"
                color="primary"
              >
                <span v-html="item.link.text" />
                <icon
                  type="chevron-right"
                  :size="0.75"
                />
              </action-link>
            </template>
          </entrance>
        </div>
      </div>
    </transition>

    <contact-info />
  </container>
</template>

<script>
import actionLink from '../components/actionLink.vue'
import checkList from '../components/checkList.vue'
import contactInfo from '../components/contactInfo.vue'
import container from '../components/container.vue'
import entrance from '../components/entrance.vue'
import icon from '../components/icon.vue'
import introduction from '../components/introduction.vue'
import paymentMethods from '../components/paymentMethods.vue'

export default {
  name: 'VIndex',

  components: {
    actionLink,
    checkList,
    contactInfo,
    container,
    entrance,
    icon,
    introduction,
    paymentMethods
  }
}
</script>

<i18n locale="en">
{
  "introduction": {
    "title": "MINIATUR WUNDERLAND TICKETS / FREE BOOKING",
    "text": "You have the choice: You can buy tickets without waiting time (even without an account) using different payment methods. If you are not a fan of online payment you can make a reservation free of charge. And of course you can also give away vouchers, which enable to bypass waiting time at available dates. We are looking forward to your visit."
  },
  "entrances": [
    {
      "title": "Buy an E-Ticket",
      "icon": "qr",
      "contenttitle": "Your Benefits:",
      "benefits": [
        "NO waiting time",
        "E-Ticket is eco-friendly",
        "Exchangeable"
      ],
      "paymentMethods": true,
      "link": {
        "text": "<strong>Buy</strong> tickets",
        "internal": "/booking"
      }
    },
    {
      "title": "YULLBE WUNDERLAND",
      "icon": "yullbe",
      "contenttitle": "The ultimate virtual reality experience at Miniatur Wunderland",
      "benefits": [
        "Wunderlandtickets ohne Zeitvorgabe",
        "KEINE Wartezeit",
        "Kombirabatt",
        "Völlig neue Perspektiven"
      ],
      "paymentMethods": true,
      "link": {
        "text": "<strong>Buy</strong> tickets",
        "internal": "/yullbe"
      }
    },
    {
      "title": "Gift Vouchers &<br>Hardtickets",
      "subtitle": "Print@Home",
      "icon": "gift",
      "contenttitle": "Your Benefits:",
      "benefits": [
        "Perfect present (via mail or as Print@Home)",
        "Select date of your choice",
        "Avoid waiting time"
      ],
      "paymentMethods": true,
      "link": {
        "text": "<strong>Buy</strong> vouchers",
        "internal": "/giftcards"
      }
    }
  ]
}
</i18n>

<i18n locale="de">
{
  "introduction": {
    "title": "MINIATUR WUNDERLAND TICKETBUCHUNG / KOSTENLOSE RESERVIERUNG",
    "text": "Sie haben die Wahl: Mit verschiedenen Zahlungsmethoden können Sie Tickets ohne Wartezeit (auch ohne einen Account anzulegen) erwerben. Wenn Sie kein Freund von Onlinezahlungen sind, haben Sie auch die Möglichkeit einer kostenlosen Reservierung. Und natürlich können Sie auch Gutscheine verschenken, mit denen Sie ebenso die Möglichkeit haben, an jedem verfügbaren Termin die Wartezeit zu umgehen. Wir freuen uns auf Sie."
  },
  "entrances": [
    {
      "title": "E-Ticket kaufen",
      "icon": "qr",
      "contenttitle": "Ihre Vorteile im Überblick:",
      "benefits": [
        "KEINE Wartezeit",
        "E-Ticket ist umweltfreundlich",
        "Umtauschbar"
      ],
      "paymentMethods": true,
      "link": {
        "text": "Tickets <strong>kaufen</strong>",
        "internal": "/buchung"
      }
    },
    {
      "title": "YULLBE WUNDERLAND<br>Tickets kaufen",
      "icon": "yullbe",
      "contenttitle": "Das ultimative Virtual Reality Erlebnis im Wunderland",
      "benefits": [
        "Wunderlandtickets ohne Zeitvorgabe",
        "KEINE Wartezeit",
        "Kombirabatt",
        "Völlig neue Perspektiven"
      ],
      "paymentMethods": true,
      "link": {
        "text": "Tickets <strong>kaufen</strong>",
        "internal": "/yullbe"
      }
    },
    {
      "title": "Papiertickets &<br>Geschenkgutscheine",
      "subtitle": "Print@home",
      "icon": "gift",
      "contenttitle": "Ihre Vorteile im Überblick:",
      "benefits": [
        "Perfekt als Geschenk (per Post oder print@home)",
        "Datum frei wählbar",
        "Möglichkeit Wartezeit zu umgehen"
      ],
      "paymentMethods": true,
      "link": {
        "text": "Gutscheine <strong>kaufen</strong>",
        "internal": "/gutscheine"
      }
    }
  ]
}
</i18n>

<style lang="scss">
@import "../css/variables";
@import "../css/mixins";

.index__section {
  @include vertical-spacing;
}

.index__item {
  height: 100%;

  text-align: center;
}

.index__back-to-home {
  text-align: center;
}

.index__check-list {
  font-size: 0.875em;
}
</style>
